export enum ShopWorkModes {
  b2bMode,
  b2CMode,
  mixed
}
